import { createAsyncThunk } from "@reduxjs/toolkit";
import APICaller from "../../utils/APICaller";
import { message } from "antd";

// Thunk for downloading month-wise expense report
export const downloadMonthWiseExpenseRequestReportThunk = createAsyncThunk(
  "expense/downloadMonthWiseExpenseRequestReport",
  async (
    {
      storeRole,
      storeToken,
      storeLIUId,
      storeAccessTokenExpiresOn,
      currentPath,
      status,
      searchKeyword,
      downloadFileName,
      month,
      exportColumns,
      exportOf,
    },
    { rejectWithValue }
  ) => {
    try {
      const exportColumns = [
        { key: "empName", path: "empName" },
        { key: "empID", path: "empID" },
        { key: "natureOfExpense", path: "natureOfExpense" },
        { key: "vendorName", path: "businessPurpose" },
        { key: "projectCodeID", path: "projectCodeID" },
        { key: "companyName", path: "" },
        { key: "expensePeriod", path: "" },
        { key: "month", path: "expensePeriodFromDate" },
        { key: "departmentID", path: "departmentID" },
        { key: "expenseCodeID", path: "" },
        { key: "currencyID", path: "" },
        { key: "cost", path: "" },
        { key: "totalReimbursement", path: "totalReimbursement" },
        { key: "approvers", path: "" },
        { key: "adminApprover", path: "" },
        { key: "status", path: "status" },
        { key: "paymentPaidOn", path: "paymentPaidOn" },
        { key: "modeOfPayment", path: "modeOfPayment" },
      ];

      // Get date range from DOM
      let startRange = "";
      let endRange = "";

      const startMonthInput = document.querySelector(
        'input[date-range="start"]'
      );
      if (startMonthInput?.value) {
        startRange = `${new Date(startMonthInput.value).getFullYear()}-${String(
          new Date(startMonthInput.value).getMonth() + 1
        ).padStart(2, "0")}`;
      }

      const endMonthInput = document.querySelector('input[date-range="end"]');
      if (endMonthInput?.value) {
        endRange = `${new Date(endMonthInput.value).getFullYear()}-${String(
          new Date(endMonthInput.value).getMonth() + 1
        ).padStart(2, "0")}`;
      }

      const payload = {
        role: storeRole,
        month,
        exportOf,
        exportColumns,
        status,
        lIUId: storeLIUId,
        searchKeyword,
      };

      const response = await APICaller(
        storeRole,
        storeToken,
        "/downloadAll",
        "POST",
        payload,
        storeAccessTokenExpiresOn,
        "blob"
      );

      if (response instanceof Blob) {
        // Handle download inside thunk (do NOT store in Redux)
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${downloadFileName}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);

        message.success("Download done successfully");
        return { success: true }; // optional metadata
      } else {
        console.error("Expected a Blob, but got:", response);
        return rejectWithValue("Failed to download file");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      return rejectWithValue(error.message || "Download failed");
    }
  }
);
